import { render, staticRenderFns } from "./ExplainEditor.vue?vue&type=template&id=13787f61&scoped=true"
import script from "./ExplainEditor.vue?vue&type=script&lang=js"
export * from "./ExplainEditor.vue?vue&type=script&lang=js"
import style0 from "./ExplainEditor.vue?vue&type=style&index=0&id=13787f61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13787f61",
  null
  
)

export default component.exports